export default "__VITE_ASSET__df78dd80__"